/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportJudgmentsCountType
 */
export interface ReportJudgmentsCountType {
    /**
     * 
     * @type {object}
     * @memberof ReportJudgmentsCountType
     */
    details: object;
    /**
     * 
     * @type {object}
     * @memberof ReportJudgmentsCountType
     */
    sum: object;
}

export function ReportJudgmentsCountTypeFromJSON(json: any): ReportJudgmentsCountType {
    return ReportJudgmentsCountTypeFromJSONTyped(json, false);
}

export function ReportJudgmentsCountTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportJudgmentsCountType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'details': json['details'],
        'sum': json['sum'],
    };
}

export function ReportJudgmentsCountTypeToJSON(value?: ReportJudgmentsCountType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'details': value.details,
        'sum': value.sum,
    };
}


